import { IventisFilterBase } from "@iventis/domain-model/model/iventisFilterBase";

export type FilterValue = string | string[] | number | number[] | Date;

export interface FilterFormat extends IventisFilterBase {
    value: FilterValue;
    $type?: FilterType;
}

export type FilterType =
    | "IventisFilterBoolean"
    | "IventisFilterDateTime"
    | "IventisFilterGuid"
    | "IventisFilterNumber"
    | "IventisFilterString"
    | "IventisFilterBooleanArray"
    | "IventisFilterDateTimeArray"
    | "IventisFilterGuidArray"
    | "IventisFilterNumberArray"
    | "IventisFilterStringArray";
